// extracted by mini-css-extract-plugin
export default {"products":"Eu-z","card":"Fu-z","oosMessaging":"Gu-z"};